import { render, staticRenderFns } from "./StatementsSubPage.vue?vue&type=template&id=5ed5da3b&scoped=true&"
import script from "./StatementsSubPage.vue?vue&type=script&lang=ts&"
export * from "./StatementsSubPage.vue?vue&type=script&lang=ts&"
import style0 from "./StatementsSubPage.vue?vue&type=style&index=0&id=5ed5da3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed5da3b",
  null
  
)

export default component.exports